/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconLocationOnFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconLocationOnFilled({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconLocationOnFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconLocationOnFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-1MihzK': alignSelf,'--mt-2-1MihzK': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1MihzK': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1MihzK': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1MihzK': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1MihzK': opacity,'--w-10-1MihzK': typeof width === 'number' ? `${width}px` : width,'--h-11-1MihzK': typeof height === 'number' ? `${height}px` : height,'--a-7-1MihzK': isAnimated ? animation : "none",'--sd-8-1MihzK': isAnimated ? strokeDashoffset : 0,'--sd-9-1MihzK': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconLocationOnFilled.SvgPath"
  data-view-path={viewPath}
 d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
 style={{'--f-12-1MihzK': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}